<template>
  <div
    class="content-page"
    style="height: 100%; width: 100%"
    v-loading="loading"
    element-loading-text="等待扫码"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div
      class="bd"
      style="height: 100%; width: 100%"
      v-loading="loading1"
      element-loading-text="等待付款完成"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addVip">新建会员</el-button>
          <el-button
            type="primary"
            size="small"
            @click="exportExcelMember"
            :disabled="VIPList.length == 0 ? true : false"
            >导出会员</el-button
          >
          <el-button
            class="upload-xls"
            type="primary"
            size="small"
            @click="uploadExcelMember"
            >批量上传会员</el-button
          >
          <el-link type="primary" class="fix-middle" :underline="false" :href="xlsLink">
            <i class="iconfont iconxiazai-copy"></i>下载会员模板
          </el-link>
        </div>
        <div class="header-right">
          <el-select
            style="width: 120px; margin-right: 20px"
            size="small"
            v-model="memberInfo.isTemporary"
            placeholder="请选择会员卡"
          >
            <el-option
              v-for="(item, index) in typeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            style="width: 220px"
            size="small"
            v-model="memberInfo.upLoadVip"
            placeholder="请选择会员卡"
          >
            <el-option
              v-for="(item, index) in vipList"
              :label="item.cardName"
              :value="item.shopMemberCardId"
              :key="index"
            ></el-option>
          </el-select>
          <el-input
            class="input-search"
            size="small"
            placeholder="输入最近几天生日"
            v-model="memberInfo.lastBirthdayDay"
          ></el-input>
          <el-input
            class="input-search"
            size="small"
            placeholder="输入多少天没消费的"
            v-model="memberInfo.lastActiveDay"
          ></el-input>
          <el-button style="margin-left: 15px" type="primary" size="small" @click="search"
            >搜索</el-button
          >
          <el-input
            placeholder="请输入会员手机号"
            v-model.trim="searchInput"
            class="input-search"
            size="small"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchVIP"></el-button>
          </el-input>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="VIPList" style="width: 100%">
            <el-table-column label="用户名">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.fullName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="会员号">
              <template slot-scope="scope">
                <div>{{ scope.row.code }}</div>
              </template>
            </el-table-column>
            <el-table-column label="购次/消费">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.totalConsumeCount }}次/{{
                    scope.row.totalConsumeMoney && scope.row.totalConsumeMoney.toFixed(2)
                  }}元
                </div>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <div>{{ scope.row.phoneNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="会员折扣">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.discount > 0 ? `${scope.row.discount}折` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="会员积分" />
            <el-table-column
              label="分销员"
              prop="isDealer"
              v-if="distributionToggle == 1"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.isDealer == 1 ? "是" : "否" }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="wallet" label="余额（元）" />
            <el-table-column label="会员类型">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isTemporary == 1 ? "临时访客" : "会员" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right" width="480">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    @click="addMessage(scope.row)"
                    plain
                    >创建消息</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="
                      distributionToggle == 1 &&
                      shopIsMaster &&
                      scope.row.isTemporary != 1
                    "
                    @click="
                      scope.row.isDealer == 1
                        ? getDealerCode(scope.row.shopMemberId)
                        : addDealer(scope.row.shopMemberId)
                    "
                    plain
                    >{{ scope.row.isDealer == 1 ? "分销码" : "开通" }}</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.isTemporary != 1"
                    @click="edit(scope.$index)"
                    plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.isTemporary != 1"
                    @click="recharge_memeber(scope.row)"
                    plain
                    >充值</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.isTemporary != 1"
                    @click="delete_memeber(scope.row)"
                    plain
                    >删除</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="modify_memeberWallet(scope.row)"
                    plain
                    >扣除余额</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogCreateVipVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ createVipForm.shopMemberId ? "编辑会员" : "新建会员" }}
      </div>
      <el-form
        :model="createVipForm"
        :rules="createVipFormRule"
        ref="createVipForm"
        label-width="68px"
        class="create-vip-form"
        :hide-required-asterisk="true"
      >
        <el-form-item label="姓名" prop="fullName">
          <el-input v-model="createVipForm.fullName" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            :disabled="createVipForm.shopMemberId ? true : false"
            v-model="createVipForm.phoneNum"
            placeholder="请填写手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="createVipForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            type="date"
            placeholder="请选择生日日期"
            v-model="createVipForm.birthday"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="地区" prop="cityName">
          <el-cascader
            v-model="createVipForm.cityName"
            :options="cityOptions"
            :props="{ expandTrigger: 'hover', value: 'value' }"
            placeholder="请选择城市"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="会员卡">
          <el-button
            v-if="!createVipForm.cardInfo"
            type="primary"
            @click="selVipCardVisible = true"
            >选择会员卡</el-button
          >
          <div
            v-else
            class="card-item"
            @click="selVipCardVisible = true"
            :style="{
              background: `linear-gradient(to bottom right, ${createVipForm.cardInfo.startValue}, ${createVipForm.cardInfo.endValue})`,
            }"
          >
            <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
            <span
              class="card-name"
              :style="{ color: `${createVipForm.cardInfo.textColor}` }"
              >{{ createVipForm.cardInfo.cardName }}</span
            >
            <span class="tips">欢迎使用本店会员卡</span>
            <span class="discount">{{ createVipForm.cardInfo.discount }}折</span>
            <span class="endtime"
              >有效期：{{
                createVipForm.cardInfo.expireType == 0
                  ? "永久"
                  : createVipForm.cardInfo.expireType == 1
                  ? createVipForm.cardInfo.expireDayNum
                  : createVipForm.cardInfo.endTime
              }}</span
            >
          </div>
        </el-form-item>
        <div v-if="createVipForm.shopMemberId" style="padding-left: 20px">
          <el-form-item label="账户余额"> {{ createVipForm.wallet }} 元 </el-form-item>
          <el-form-item label="累计积分">
            {{ createVipForm.totalScore }} 个
          </el-form-item>
          <el-form-item label="累计消费">
            {{ createVipForm.totalConsumeMoney }} 元
          </el-form-item>
          <el-form-item label="累计次数">
            {{ createVipForm.totalConsumeCount }} 笔
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="createVipForm.remark"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定微信">
            {{ createVipForm.isBindWx ? "已绑定微信" : "未绑定微信" }}
            <el-button
              v-if="!createVipForm.isBindWx"
              type="primary"
              size="small"
              @click="oldShopMemberBindWxCodeFuc"
              >绑定</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createVip" :loading="isSubmit">{{
          createVipForm.shopMemberId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogCreateVipVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
      :visible.sync="selVipCardVisible"
      @close="vipCardDialogClose"
      append-to-body
    >
      <div slot="title" class="dialog-title">选择会员卡</div>
      <div class="card-List">
        <el-radio-group v-model="selCard">
          <el-radio
            :label="index"
            v-for="(item, index) in cardList"
            :key="item.shopMemberCardId"
            v-if="isExpire(item)"
          >
            <div
              class="card-item"
              :style="{
                background: `linear-gradient(to bottom right, ${item.startValue}, ${item.endValue})`,
              }"
            >
              <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
              <span class="card-name" :style="{ color: `${item.textColor}` }">{{
                item.cardName
              }}</span>
              <span class="tips">欢迎使用本店会员卡</span>
              <span class="discount">{{ item.discount }}折</span>
              <span class="endtime"
                >有效期：{{
                  item.expireType == 0
                    ? "永久"
                    : item.expireType == 1
                    ? item.expireDayNum
                    : item.endTime
                }}</span
              >
            </div>
          </el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-upload
          class="upload-xls-btn"
          action="/edcmanageapi/ShopMember_importShopMember"
          :http-request="importShopMember"
          :show-file-list="false"
          v-if="isUpload"
          :disabled="!isNaN(parseInt(selCard)) ? false : true"
        >
          <el-button type="primary" :disabled="!isNaN(parseInt(selCard)) ? false : true"
            >选择确认</el-button
          >
        </el-upload>
        <el-button
          type="primary"
          @click="createVipCard"
          :disabled="!isNaN(parseInt(selCard)) ? false : true"
          v-if="!isUpload"
          >选择确认</el-button
        >
        <el-button @click="selVipCardVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="分销码"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <span
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <canvas id="canvas" style="width: 80%; height: 100px" />
        <div>
          <el-button type="primary" @click="downloadCode">下载分销码</el-button>
        </div>
      </span>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogcreateMessageVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="msgDialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">添加消息</div>
      <el-form
        :model="createMessageForm"
        :rules="createMessageFormRule"
        ref="createMessageForm"
        label-width="128px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="消息类型" prop="msgContentType">
          <el-select
            v-model="createMessageForm.msgContentType"
            size="small"
            placeholder="请选择消息类型"
          >
            <el-option
              v-for="item in msgContentTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-if="item.value && item.value != 1 && item.value != 2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息标题" prop="msgTitle">
          <el-input
            v-model="createMessageForm.msgTitle"
            placeholder="请填写消息标题"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="msgContent">
          <el-input
            v-model="createMessageForm.msgContent"
            placeholder="请填写消息内容"
            size="small"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="消息资源链接" prop="msgResLink">
          <el-input
            v-model="createMessageForm.msgResLink"
            placeholder="请填写消息资源链接"
            size="small"
          ></el-input>
        </el-form-item> -->
        <template
          v-if="
            createMessageForm.msgContentType != 1 && createMessageForm.msgContentType != 2
          "
        >
          <el-form-item label="活动标题" prop="msgCustomContent.pTile">
            <el-input
              v-model="createMessageForm.msgCustomContent.pTile"
              placeholder="请填写活动标题"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动内容" prop="msgCustomContent.pContent">
            <el-input
              v-model="createMessageForm.msgCustomContent.pContent"
              placeholder="请填写活动内容"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="截止时间" prop="msgCustomContent.time">
            <el-date-picker
              v-model="createMessageForm.msgCustomContent.time"
              type="datetime"
              placeholder="选择截止时间"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="券批次ID"
            prop="msgCustomContent.cashCouponBatchOrderId"
            v-if="
              createMessageForm.msgContentType == 5 ||
              createMessageForm.msgContentType == 6
            "
          >
            <el-select
              v-model="createMessageForm.msgCustomContent.cashCouponBatchOrderId"
              size="small"
              placeholder="请选择券批次ID"
            >
              <el-option
                v-for="item in cashCouponList[this.createMessageForm.msgContentType]"
                :key="item.cashCouponBatchOrderId"
                :label="item.title"
                :value="item.cashCouponBatchOrderId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createMessage" :loading="isSubmit">{{
          createMessageForm.lifePayInstitutionId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogcreateMessageVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="vipDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">充值会员</div>
      <div class="vipCard">
        <div
          class="changeColor"
          :style="{
            background: `linear-gradient(to bottom right, ${vipDetailList.startValue}, ${vipDetailList.endValue}`,
            height: '200px',
            width: '340px',
          }"
        ></div>
        <div class="name" :style="{ color: vipDetailList.textColor, fontSize: '20px' }">
          {{ vipDetailList.cardName }}
        </div>
        <div class="welcome" style="font-size: 16px; margin-top: 15px">
          {{ vipDetailList.cardSlogan }}
        </div>
      </div>
      <div class="price">
        <span>充值金额：</span>
        <div style="width: 275px">
          <el-input
            v-model="rechargeNum"
            placeholder="输入金额"
            @blur="rechargeNumBlur"
          ></el-input>
        </div>
      </div>
      <div class="price">
        <span>营业员：</span>
        <el-select v-model="shopWorkerUserId" placeholder="请选择">
          <el-option
            v-for="item in salesList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="money">
        <div class="button7" v-for="(item, index) in activityList" :key="index">
          {{ item.rechargeMoney }}元送{{ item.handselMoney }}元
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" plain type="primary" @click="recharge(1)"
          >现金收款</el-button
        >
        <el-button size="medium" type="primary" @click="recharge(2)">扫码收款</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="visibleBindWxQrcode"
      title="绑定微信"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
      :show-close="true"
    >
      <div style="text-align: center">
        <div class="bind-wx-qrcode-box">
          <qrcode
            :value="bindWxQrcode"
            :options="{ size: 300 }"
            class="bind-wx-qrcode"
          ></qrcode>
          <img src="@/assets/icon/yiCity.png" style="height: 364px; width: 340px" alt />
        </div>
        <div style="font-size: 15px; margin-top: 20px">
          请顾客使用微信扫一扫关注（易城市APP）完成绑定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";
import cityJson from "@/assets/js/cityData.json";
import {
  getShopMemberCardList,
  getShopMemberList,
  getShopMemberListNum,
  getBindWxQrValue,
  modifyShopMember,
  exportExcelMember,
  importShopMember,
  removeShopMember,
  getDistributionConfig,
  addDealer,
  getDealerCode,
  createShopNoticeMessage,
  getCashCouponDtosForShoperSend,
  getShopMemberActivityList,
  shopMemberRecharge,
  Pay_userPayScan,
  findSaleShopWorks,
  modifyMemberWallet,
  oldShopMemberBindWxCode,
} from "@/api/index.js";
import { constants } from "crypto";
import request from "@/utils/request";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
import qrcode from "@xkeshi/vue-qrcode";
import { createScannerInput } from "@/utils/scannerInput";

export default {
  mixins: [commonFuc],
  data() {
    return {
      bindWxQrcode: "",
      visibleBindWxQrcode: false,
      xlsLink: `${request.baseUrl}/download/导入会员模板.xls`,
      VIPList: [],
      cardList: [],
      selCard: "",
      searchInput: "",
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      dialogCreateVipVisible: false,
      selVipCardVisible: false,
      dialogVisible: false,
      createVipForm: {
        fullName: "",
        phoneNum: "",
        sex: 1,
        birthday: "",
        cityName: [],
        provinceId: 0,
        cityId: 0,
        districtId: 0,
        shopMemberCardId: "",
        cardInfo: null,
        remark: "",
      },
      createVipFormRule: {
        fullName: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur",
            type: "mobile",
          },
        ],
        // birthday: [
        //     {
        //         required: true,
        //         message: "请选择生日日期",
        //         trigger: "blur"
        //     }
        // ],
        // cityName: [
        //     {
        //         required: true,
        //         message: "请选择地区",
        //         trigger: "blur"
        //     }
        // ]
      },
      cityOptions: cityJson,
      isSubmit: false,
      isUpload: false,
      distributionToggle: "",
      typeList: [
        {
          label: "会员",
          value: 0,
        },
        {
          label: "临时访客",
          value: 1,
        },
      ],
      msgContentTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "富文本",
          value: 1,
        },
        {
          label: "链接消息",
          value: 2,
        },
        {
          label: "微信小程序订阅消息",
          value: 3,
        },
        {
          label: "支付宝小程序订阅消息",
          value: 4,
        },
        {
          label: "微信主动推券",
          value: 5,
        },
        {
          label: "支付宝主动推券",
          value: 6,
        },
      ],
      dialogcreateMessageVisible: false,
      createMessageForm: {
        receiveUserId: "",
        msgContentType: 3,
        msgTitle: "",
        msgContent: "",
        msgResLink: "",
        msgCustomContent: {
          pTile: "",
          pContent: "",
          time: "",
          cashCouponBatchOrderId: "",
        },
        msgPushType: 10,
      },
      cashCouponList: {},
      createMessageFormRule: {
        msgTitle: [
          {
            required: true,
            message: "请填写消息标题 ",
            trigger: "blur",
          },
        ],
        msgContent: [
          {
            required: true,
            message: "请填写消息内容",
            trigger: "blur",
          },
        ],
        "msgCustomContent.pTile": [
          {
            required: true,
            message: "请填写活动标题",
            trigger: "blur",
          },
        ],
        "msgCustomContent.pContent": [
          {
            required: true,
            message: "请填写活动内容",
            trigger: "blur",
          },
        ],
        "msgCustomContent.time": [
          {
            required: true,
            message: "请选择截止时间",
            trigger: "blur",
          },
        ],
        "msgCustomContent.cashCouponBatchOrderId": [
          {
            required: true,
            message: "请填写券批次ID",
            trigger: "blur",
          },
        ],
      },
      vipDialogVisible: false,
      vipDetailList: {},
      rechargeNum: "",
      activityList: [],
      playCode: false,
      codeMsg: "",
      mallOrderId: "",
      loading: false,
      loading1: false,
      intervalNum: 0, //循环次数
      intervalStart: false, //开始循环
      vipList: [],
      memberInfo: {
        upLoadVip: "",
        lastBirthdayDay: "",
        lastActiveDay: "",
        isTemporary: 0,
      },
      salesList: [],
      shopWorkerUserId: "",
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
  },
  watch: {
    searchInput(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    codeMsg: function (oldValue, newValue) {
      console.log(this.codeMsg, "code改变");
      if (
        this.codeMsgScanner &&
        this.codeMsgScanner.isScanMode() &&
        this.codeMsg.length == 18
      ) {
        this.loading = false;
        this.loading1 = true;
        this.Pay_userPayScan();
        document.onkeydown = null;
        this.codeMsgScanner.reset();
      }
    },
  },
  mounted() {
    if (this.$route.query.type == "addvip") {
      this.addVip();
    }
    this.getPageData();
    this.getCashCouponDtosForShoperSend();
  },
  methods: {
    oldShopMemberBindWxCodeFuc() {
      oldShopMemberBindWxCode({
        shopMemberId: this.createVipForm.shopMemberId,
      }).then((res) => {
        if (res.code == 1) {
          this.bindWxQrcode = res.data.qrCode;
          if (this.isOwn) {
            this.visibleBindWxQrcode = true;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getCashCouponDtosForShoperSend() {
      getCashCouponDtosForShoperSend({
        msgContentType: 5,
      }).then((res) => {
        if (res.code == 1) {
          this.cashCouponList[5] = res.data;
        }
        if (res.code == -1) {
          this.cashCouponList[5] = [];
        }
      });
      getCashCouponDtosForShoperSend({
        msgContentType: 6,
      }).then((res) => {
        if (res.code == 1) {
          this.cashCouponList[6] = res.data;
        }
        if (res.code == -1) {
          this.cashCouponList[6] = [];
        }
      });
    },
    search() {
      console.log(this.memberInfo, "memberInfo");
      this.getPageData();
    },
    findSaleShopWorks() {
      findSaleShopWorks().then((res) => {
        if (res.code == 1) {
          this.salesList = res.data;
        }
      });
    },
    //会员充值
    recharge(e) {
      if (this.rechargeNum == "") {
        this.$message.warning("充值金额不能为空哦");
        return;
      }
      if (e == 1) {
        console.log("调用会员充值");
        this.$confirm("确认充值会员卡吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            shopMemberRecharge({
              shopMemberId: this.vipDetailList.shopMemberId,
              payMoney: this.rechargeNum, //消费金额
              orderCategory: 8, //订单类型   1,"系统代收款"  2,"店铺收银"  3,"外卖订单"  4,"秒杀订单"  5,"点餐订单"  6,"线下订单"  7,"线上订单"  8,"会员卡订"  9,"缴费账单
              shopStoreId: this.shopInfo.shopStoreId,
              receiptType: e, //付款类型   1 现金收款 2扫码收款
              saleUserId: this.shopWorkerUserId,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success("充值成功");
                this.rechargeNum = "";
                this.vipDialogVisible = false;
                this.shopWorkerUserId = "";
                this.getPageData();
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        shopMemberRecharge({
          shopMemberId: this.vipDetailList.shopMemberId,
          payMoney: this.rechargeNum, //消费金额
          orderCategory: 8,
          shopStoreId: this.shopInfo.shopStoreId,
          receiptType: e,
          saleUserId: this.shopWorkerUserId,
        }).then((res) => {
          if (res.code == 1) {
            this.rechargeNum = "";
            this.shopWorkerUserId = "";
            this.mallOrderId = res.data.mallOrderId;
            if (e == 2) {
              this.playCode = true;
              this.codeMsgScanner = createScannerInput({
                getValue: () => this.codeMsg,
                setValue: (value) => {
                  this.codeMsg = value;
                },
                onEnter: async () => {
                  this.loading = false;
                  this.loading1 = true;
                  this.Pay_userPayScan();
                  document.onkeydown = null;
                },
              });
              document.onkeydown = this.codeMsgScanner.handleKeydown;
              console.log(this.codeMsg, "codeMsg");
              this.loading = true;
              this.vipDialogVisible = false;
            }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    Pay_userPayScan() {
      console.log(this.codeMsg, "Pay_userPayScan");
      Pay_userPayScan({
        mallOrderId: this.mallOrderId, //订单id
        auth_code: this.codeMsg, //收款码
      }).then((res) => {
        if (res.code == 1) {
          setTimeout(() => {
            this.loading = false;
            this.loading1 = false;
            this.$message.success("充值成功");
            this.getPageData();
            this.rechargeNum = "";
            this.mallOrderId = "";
            this.codeMsg = "";
            if (this.codeMsgScanner) {
              this.codeMsgScanner.reset();
            }
          }, 2000);
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getShopMemberActivityList(shopMemberCardId) {
      getShopMemberActivityList({
        shopMemberCardId: shopMemberCardId,
      }).then((res) => {
        console.log(res, "shopMemberActivityList");
        if (res.code == 1) {
          // var list = res.data[0].shopMemberCardIds.split(',')
          this.activityList = JSON.parse(res.data[0].itemContent);
          console.log(this.activityList, "22");
        } else if (res.code == -1) {
          this.activityList = "";
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
        } else {
        }
      });
    },
    getPageData() {
      this.pageNo = 1;
      this.getShopMemberList();
      this.getConfig();
      this.getShopMemberListNum();
      this.getShopMemberCardList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getConfig() {
      getDistributionConfig({}).then((res) => {
        if (res.code == 1) {
          this.distributionToggle = res.data.distributionToggle;
          console.log(res.data.distributionToggle);
        }
      });
    },
    addDealer(params) {
      addDealer({
        shopMemberId: params,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "开通成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
        }
      });
    },
    getDealerCode(params) {
      getDealerCode({
        shopMemberId: params,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res.data.url);
          setTimeout(() => {
            this.useqrcode(res.data.url); // 此为绘画canvas的方法调用
          }, 0);
          this.dialogVisible = true;
        }
      });
    },
    useqrcode(qrCodeUrl) {
      this.QueryDetail = qrCodeUrl;
      console.log(this.QueryDetail, "this.QueryDetail");
      var canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, this.QueryDetail, function (error) {
        if (error) console.error(error);
        // console.log("success");
      });
    },
    downloadCode() {
      let link = document.createElement("a");
      link.href = canvas.toDataURL(); //下载链接
      link.setAttribute("download", "qrcode.png");
      link.style.display = "none"; //a标签隐藏
      document.body.appendChild(link);
      link.click();
      this.dialogVisible = false;
    },
    getShopMemberList() {
      getShopMemberList({
        pageNo: this.pageNo,
        row: this.pageSize,
        phoneNum: String(this.searchInput),
        shopMemberCardId: this.memberInfo.upLoadVip,
        lastBirthdayDay: this.memberInfo.lastBirthdayDay,
        lastActiveDay: this.memberInfo.lastActiveDay,
        isShowTemporary: 1,
        isTemporary: this.memberInfo.isTemporary,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.discount = (val.discount * 10).toFixed(1);
          });
          this.VIPList = res.data;
        }
        if (res.code == -1) {
          this.VIPList = [];
        }
      });
    },
    getShopMemberListNum() {
      getShopMemberListNum({
        code: String(this.searchInput),
        shopMemberCardId: this.memberInfo.upLoadVip,
        lastBirthdayDay: this.memberInfo.lastBirthdayDay,
        lastActiveDay: this.memberInfo.lastActiveDay,
        isShowTemporary: 1,
        isTemporary: this.memberInfo.isTemporary,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    getShopMemberCardList() {
      getShopMemberCardList({
        row: 1000,
        isEnable: 1,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.discount = (val.discount * 10).toFixed(1);
          });
          this.cardList = res.data;
          this.vipList = JSON.parse(JSON.stringify(res.data));
        }
        if (res.code == -1) {
          this.cardList = [];
        }
        this.cardList.forEach((val) => {
          if (val.shopMemberCardId == this.createVipForm.shopMemberCardId) {
            this.createVipForm.cardInfo = val;
          }
        });
      });
    },
    searchVIP() {
      if (!(this.searchInput * 1)) {
        this.$notify({
          title: "警告",
          message: "请输入会员手机号",
          type: "warning",
        });
        return;
      }
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getShopMemberList();
    },
    modify_memeberWallet(row) {
      this.$prompt("", "会员扣除余额", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\d+/,
        inputErrorMessage: "必须输入数字",
        inputPlaceholder: "请输入金额",
      })
        .then(({ value }) => {
          // console.log(value)
          // console.log(row, 234, row.shopMemberId)
          // return
          modifyMemberWallet({
            shopMemberId: row.shopMemberId,
            tranMoney: value,
          }).then((res) => {
            if (res.code == 1) {
              this.getPageData();
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {});
    },
    delete_memeber(row) {
      this.$confirm("您确定要删除该会员吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeShopMember({
            shopMemberId: row.shopMemberId,
          }).then((res) => {
            if (res.code == 1) {
              this.getPageData();
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {});
    },
    rechargeNumBlur(e) {
      let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(e.target.value)) {
        this.rechargeNum = "";
        this.$message.error("请输入正确的充值金额");
      } else {
        this.rechargeNum = Number(e.target.value);
      }
    },
    recharge_memeber(row) {
      console.log(row, "vipDetailList");
      this.findSaleShopWorks();
      this.getShopMemberActivityList(row.shopMemberCardId);
      this.vipDialogVisible = true;
      this.vipDetailList = row;
    },
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.createVipForm));
      let viplist = JSON.parse(JSON.stringify(this.VIPList[index]));
      Object.assign(params, viplist);

      params.cityName = params.districtId
        ? [String(params.provinceId), String(params.cityId), String(params.districtId)]
        : [String(params.provinceId), String(params.cityId)];

      this.createVipForm = params;
      this.getShopMemberCardList();
      this.addVip();
    },
    dialogClose() {
      this.createVipForm = {
        fullName: "",
        phoneNum: "",
        sex: 1,
        birthday: "",
        cityName: [],
        provinceId: 0,
        cityId: 0,
        districtId: 0,
        shopMemberCardId: "",
        cardInfo: null,
        remark: "",
      };
      this.$refs.createVipForm.resetFields();
    },
    vipCardDialogClose() {
      this.isUpload = false;
    },
    addVip() {
      this.dialogCreateVipVisible = true;
    },
    createVip() {
      this.$refs.createVipForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createVipForm));
          params.provinceId = params.cityName[0];
          params.cityId = params.cityName[1];
          params.districtId = params.cityName[2] || "";
          params.birthday = String(params.birthday.split("T")[0]);
          console.log(params.shopMemberId, "params.shopMemberId");
          if (params.shopMemberId) {
            modifyShopMember(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: params.shopMemberId ? "编辑成功" : "创建成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.dialogCreateVipVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            getBindWxQrValue(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "新增成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.dialogCreateVipVisible = false;
                this.bindWxQrcode = res.data.qrCode;
                this.visibleBindWxQrcode = true;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    createVipCard() {
      let params = JSON.parse(JSON.stringify(this.createVipForm));
      params.cardInfo = JSON.parse(JSON.stringify(this.cardList[this.selCard]));
      params.shopMemberCardId = JSON.parse(
        JSON.stringify(this.cardList[this.selCard].shopMemberCardId)
      );
      this.createVipForm = params;
      this.selVipCardVisible = false;
    },
    importShopMember(item) {
      if (!~item.file.name.indexOf(".xls")) {
        this.$notify({
          title: "警告",
          message: "请上传xls格式文件",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      imgUploadForm.append(
        "shopMemberCardId",
        this.cardList[this.selCard].shopMemberCardId
      );
      importShopMember(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "导入成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
        }
        if (res.code == 0) {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
        this.selVipCardVisible = false;
      });
    },
    exportExcelMember() {
      location.href = `${request.baseUrl}/edcmanageapi/ShopMember_exportExcelMember?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}`;
    },
    uploadExcelMember() {
      this.selVipCardVisible = true;
      this.isUpload = true;
    },
    isExpire(data) {
      if (data.expireType == 1) {
        if (data.expireDayNum <= 0) {
          return false;
        }
      }
      if (data.expireType == 2) {
        if (+new Date(data.endTime) - +new Date() <= 0) {
          return false;
        }
      }
      return true;
    },
    msgDialogClose() {
      (this.createMessageForm = {
        receiveUserId: "",
        msgContentType: 3,
        msgTitle: "",
        msgContent: "",
        msgResLink: "",
        msgCustomContent: {
          pTile: "",
          pContent: "",
          time: "",
          cashCouponBatchOrderId: "",
        },
        msgPushType: 10,
      }),
        this.$refs.createMessageForm.resetFields();
    },
    addMessage(item) {
      this.createMessageForm.receiveUserId = item.customerUserId;
      this.dialogcreateMessageVisible = true;
    },
    createMessage() {
      this.$refs.createMessageForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createMessageForm));
          params.msgCustomContent.time = new Date(params.msgCustomContent.time).pattern(
            "yyyy-MM-dd HH:mm:ss"
          );
          params.msgCustomContent = JSON.stringify(params.msgCustomContent);
          createShopNoticeMessage(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "创建成功",
                type: "success",
                duration: 2000,
              });
              this.getPageData();
              this.dialogcreateMessageVisible = false;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            setTimeout(() => {
              this.isSubmit = false;
            }, 500);
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.money div {
  display: inline-block;
}
.money {
  width: 340px;
}
.button7 {
  height: 20px;
  padding: 0 25px;
  color: #409eff;
  border: 1px solid #409eff;
  font-size: 13px;
  border-radius: 2px;
  padding-top: 5px;
  margin-left: 10px;
  margin-top: 15px;
}
.vipCard {
  position: relative;
  margin-top: 20px;
  margin-left: 10px;
}
.vipCard .name {
  color: #c3445e;
  font-size: 14px;
  position: absolute;
  top: 9px;
  left: 25px;
  font-weight: 1000;
}
.vipCard .welcome {
  font-size: 12px;
  color: #fff;
  position: absolute;
  top: 32px;
  left: 25px;
}
.vipCard .time {
  font-size: 12px;
  color: rgb(250, 250, 250);
  position: absolute;
  top: 67px;
  left: 25px;
}
.vipCard .discount {
  text-align: right;
  width: 55px;
  font-size: 12px;
  color: rgb(250, 250, 250);
  position: absolute;
  top: 33px;
  left: 147px;
}
.changeColor {
  height: 123px;
  width: 196px;
  margin-left: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px #888888;
}
.price {
  display: flex;
  align-items: center;
  font-size: 13px;
  width: 340px;
  margin-top: 20px;
}
.content-page {
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
  }
  .el-cascader {
    width: 100%;
  }
}
.card-List {
  height: 480px;
  min-height: 480px;
  overflow: auto;
  text-align: center;
  .el-radio {
    margin-right: 0;
  }
}
.card-item {
  width: 297px;
  height: 172px;
  border-radius: 20px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: 40px;
  margin-bottom: 20px;
  box-shadow: -2px 8px 30px #afafaf;
  & > span {
    position: absolute;
  }
  button + & {
    margin-top: 20px;
  }
  .card-bg {
    top: 50%;
    position: absolute;
    left: -25%;
    transform: translateY(-50%);
  }
  .card-name {
    font-size: 20px;
    font-weight: bold;
    left: 20px;
    top: 20px;
  }
  .tips {
    font-size: 14px;
    color: #fafafa;
    left: 20px;
    top: 54px;
  }
  .discount {
    font-size: 30px;
    color: #fafafa;
    top: 54px;
    right: 20px;
  }
  .endtime {
    font-size: 14px;
    color: #fafafa;
    left: 20px;
    bottom: 20px;
  }
}
.bind-wx-qrcode-box {
  position: relative;
}
.bind-wx-qrcode {
  position: absolute;
  top: 59%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 250px;
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
.create-vip-form {
  height: 500px;
  overflow: auto;
}
</style>
